import React, { useEffect, useCallback, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedCategory } from "../redux/categoriesSlice";
import { clearPosts } from "../redux/postsSlice";
import { usePost } from "../hooks/usePost";
import { FaBars, FaTimes, FaHome, FaLayerGroup, FaChevronDown } from "react-icons/fa";
import "./Styles/Styles.scss";
import "./Styles/animations.scss";
import MobileCategoryBar from "./Components/MobileCategoryBar/MobileCategoryBar";

const Layout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { fetchCategories } = usePost();
  const categories = useSelector((state) => state.categories.entities) || [];
  const selectedCategory = useSelector((state) => state.categories.selectedCategory);
  const logo = useSelector((state) => state.projectInfo.logo);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  // Fetch categories on component mount
  useEffect(() => {
    const loadCategories = async () => {
      try {
        await fetchCategories();
      } catch (error) {
        console.error("Error loading categories:", error);
      }
    };
    
    loadCategories();
  }, []);

  const onCategoryClick = useCallback((category) => {
  const isSameCategory = selectedCategory === category;
  const targetPath = category === undefined ? "/community" : `/community/categories/${category}`;

  if (isSameCategory) {
    navigate(targetPath);
    return;
  }
  sessionStorage.setItem("ScrollPosition", 0);
  dispatch(clearPosts());
  dispatch(setSelectedCategory(category));
  setSidebarOpen(false);
  navigate(targetPath);
}, [dispatch, navigate, selectedCategory]);

  // Close sidebar when clicking outside on mobile
  useEffect(() => {
    const handleClickOutside = (event) => {
      const sidebar = document.querySelector(".community-sidebar");
      const toggleButton = document.querySelector(".sidebar-toggle");
      const categoryBar = document.querySelector(".mobile-category-bar");

      if (
        sidebarOpen &&
        sidebar &&
        !sidebar.contains(event.target) &&
        toggleButton &&
        !toggleButton.contains(event.target) &&
        (!categoryBar || !categoryBar.contains(event.target))
      ) {
        setSidebarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [sidebarOpen]);
  return (
    <>
      <div className="community-page">
        {/* Mobile Toggle Button - only visible on non-mobile view */}
        <button
          className="sidebar-toggle desktop-only hover-elevate"
          onClick={() => setSidebarOpen(!sidebarOpen)}
          aria-label={sidebarOpen ? "Close sidebar" : "Open sidebar"}
        >
          {sidebarOpen ? <FaTimes className="fade-in" /> : <FaBars className="fade-in" />}
          <span className="toggle-text">{sidebarOpen ? "Close" : "Categories"}</span>
        </button>

        {/* Mobile Category Bar - only visible on mobile */}
        <MobileCategoryBar onClick={() => setSidebarOpen(true)} />

        {/* Sidebar */}
        <div className={`community-sidebar ${sidebarOpen ? 'open' : ''}`}>
          {/* Mobile-only sidebar header */}
          <div className="sidebar-header mobile-only">
            {logo && 
              <a href={window.location.origin}>
                <img src={logo}
                  className="sidebar-logo"
                  alt="Logo"
                />
                </a>
              }
            {/* <h3>Categories</h3> */}
            <button
              className="close-sidebar"
              onClick={() => setSidebarOpen(false)}
              aria-label="Close sidebar"
            >
              <FaTimes />
            </button>
          </div>

          <div className="sidebar-divider mobile-only"></div>
          <div className="sidebar-menu" onClick={() => onCategoryClick(undefined)}>
            <div className={`menu-item home-item${selectedCategory === undefined ? " active" : ""} hover-grow`}>
              <FaHome className="menu-icon" />
              <span>Home</span>
            </div>
          </div>

          <div className="sidebar-categories">
            <div className="category-header">
              <FaLayerGroup className="category-icon" />
              <h4>Browse Categories</h4>
            </div>
            {categories && categories?.length > 0 ? (
              <div className="category-list">
                {categories.map(category => (
                  <div
                    key={category.id}
                    className={`category-item ${Number(selectedCategory) === category.id ? 'active' : ''} hover-elevate`}
                    onClick={() => onCategoryClick(category.id)}
                  >
                    <span>{category.name}</span>
                    {selectedCategory === category.id && <div className="active-indicator"></div>}
                  </div>
                ))}
              </div>
            ) : (
              <div className="no-categories-message">
                {/* <p className="no-categories-subtitle">Loading...</p> */}
                <p>No categories available</p>
                <p className="no-categories-subtitle">Categories will appear here when available</p>
              </div>
            )}
          </div>

          {/* <div className="sidebar-footer">
          <p>© {new Date().getFullYear()} Community</p>
        </div> */}
        </div>      {/* Main Content Area */}
        <div className="community-content">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default Layout;